import { ChoicePair } from "../constant/types";

export default (state = [], action: { type: string, payload :ChoicePair []}) => {
  switch (action.type) {
    case "APP_CHOICES":      
      return action.payload;
    default:
      return state;
  }
}